import React from 'react';

export default function AuthenticateReview() {
  return (
    <div>
      ((Authenticate Review))
    </div>
  );
}
